// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import HeatBasic from '@/features/dashboards/layouts/HeatBasic';

export const Route = createFileRoute('/$accountId/_user/dashboards/heat-basic')(
  {
    component: HeatBasic,
    staticData: { crumb: 'dashboards-heat-basic:title' },
  },
);
